import { render } from "./BaseCheckbox.vue?vue&type=template&id=295a61c8&ts=true"
import script from "./BaseCheckbox.vue?vue&type=script&lang=ts"
export * from "./BaseCheckbox.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__